export default {
	back_home: 'Back to home',
	buy_now: 'Buy now',
	data_disk: 'Data disk',
	empty: 'No products available',
	invoice_not_found: 'Invoice not found or link has expired',
	package: 'Package',
	per_month: '/mo',
	server_desc: 'Dedicated hardware, high performance, large bandwidth, extra IPs available',
	server_title: 'Dedicated physical server',
	system_disk: 'System disk',
	vps_desc: 'High performance, high availability, great value',
	vps_title: 'VPS Cloud Server',
}
